import { ConditionalFunctionString } from '../../conditions.types'

// Matches when the property value is found in the selected values array
export const arrayIncludes: ConditionalFunctionString = ({ property, value }) =>
  `${JSON.stringify(value)}.indexOf(${property}) !== -1`

// Matches when the property value is NOT found in the selected values array
export const arrayExcludes: ConditionalFunctionString = ({ property, value }) =>
  `${JSON.stringify(value)}.indexOf(${property}) === -1`

// Matches when ALL selected values appear in the property array
export const arrayIncludesAll: ConditionalFunctionString = ({
  property,
  value
}) =>
  `${JSON.stringify(value)}.every(function(id) { return ${property}.indexOf(id) !== -1; })`

// Matches when NONE of the selected values appear in the property array
export const arrayExcludesAll: ConditionalFunctionString = ({
  property,
  value
}) =>
  `${JSON.stringify(value)}.every(function(id) { return ${property}.indexOf(id) === -1; })`
